import React, { useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import PropTypes from 'prop-types';
import css from './SignatureBox.css';

const SignatureBox = ({ onSignatureChange, handleSignProtocol }) => {
  const sigCanvas = useRef(null);
  const [trimmedDataURL, setTrimmedDataURL] = useState(null);
  const [blobSig, setBlobSig] = useState(null);

  function clear() {
    sigCanvas.current.clear()
  }

  function trim() {
    sigCanvas.current.getTrimmedCanvas().toBlob((blob) => {
      console.log(blob)
      // setBlobSig(blob)
      console.log(blob)
      handleSignProtocol(blob, 'pickup')
    })
    setTrimmedDataURL(sigCanvas.current.getTrimmedCanvas().toDataURL('image/png'))
  }

  return (
    <div>
      <div className={css.sigContainer}>
        <SignatureCanvas
          penColor="green"
          canvasProps={{ height: 500, className: css.sigCanvas }}
          ref={sigCanvas}
        />
        <div>
          <button className={css.buttons} type="button" onClick={clear}>Wyczyść</button>
          <button className={css.buttons} type="button" onClick={trim}>Przytnij</button>
        </div>
        {trimmedDataURL && (
          <img className={css.sigImage} alt="signature" src={trimmedDataURL} />
        )}
      </div>
    </div>
  );
};

SignatureBox.propTypes = {
  onSignatureChange: PropTypes.func.isRequired,
};

export default SignatureBox;
